/*@flow*/
import { useContext, createElement } from 'react';
import FormContext from '../context';
import useField from './useField';
import nested from 'lib/nested';
import getFieldInfo from '../util/getFieldInfo';
import factory from '../components/factory';
import type { PathT } from '../types';

export default function useStructInputs(path: PathT): {...} {
  const ctx = useContext(FormContext);
  const { type: rootType, value: rootValue } = ctx.state;

  // Inspect the types nested into the type of this field. For each type,
  // use helper functions `factory` and `getTypeFromUnion` to find a
  // component that would render it. Then render these subcomponents, passing
  // as prop only their path with respect to the top of the form hierarchy.
  const inputs = {};
  const { typeInfo } = useField(path);
  const typeProps = nested<{}>(typeInfo, 'innerType.meta.props', {});

  const buildInput = k => {
    const pathFromRoot: PathT = path.concat([k]);
    // TODO: memo
    const { fieldOptions, fieldType } = getFieldInfo(
      pathFromRoot,
      rootType,
      rootValue
    );

    const SubComp = factory(fieldType, fieldOptions);
    inputs[k] = createElement(SubComp, { path: pathFromRoot, key: k });
  };
  Object.keys(typeProps).forEach(buildInput);
  return inputs;
}
